import React, { Component } from 'react';
import { Link } from 'react-router';

import routeConfig from '../config/route.json';

import '../css/bg.css';
import '../css/landing.css';

import $ from 'jquery';

class Landing extends Component {

  constructor(props) {
    super(props);
    this.state = {
    	...this.props,
    	'bg': '/bg/landing/bg.jpg',
      'bgLogo': '/bg/landing/logo-fit.png'
    }
  }

  componentDidMount() {
    $('#loader').fadeOut(1000)
    this.changePositioning();
    // setTimeout(function(){
    //   console.log('componentDidMount')
    //   $('#footer-panel-layer').removeClass('show-footer-panel-layer');
    //   $('#footer-panel-layer').css({"z-index": "-10"});
    // }, 50)
    window.addEventListener('resize', this.changePositioning);

    // document.getElementById('footer-panel-layer').classList.remove('show-footer-panel-layer');
    // document.getElementById('App-header').style.opacity = '0';
    // document.getElementById('App-footer').style.opacity = '0';
    $('#App-header').fadeOut();
    $('#App-footer').fadeOut();
  }

  componentWillUpdate(){
  }


  componentWillUnmount(){
    document.getElementById('App-header').style.opacity = '1';
    document.getElementById('App-footer').style.opacity = '1';
    $('#App-header').fadeIn();
    $('#App-footer').fadeIn();

    window.removeEventListener('resize', this.changePositioning);
  
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    // if (windowWidth < 1100) {
    //   windowWidth = 1100
    // }

    // let landingButtonTop = windowWidth * 0.45218 + 'px';
    // let landingButtonHeight = windowWidth * 0.016 + 'px';

    // let landingButton = document.getElementsByClassName('landing-button');

    // for (let i = 0; i < landingButton.length; i++) {
    //   landingButton[i].style.top = landingButtonTop
    //   landingButton[i].style.height = landingButtonHeight
    // }

    console.log($('#logo-container').width());
    let containerWidth = $('#logo-container').width();
    $('.landing-button').css({
      'height': containerWidth * 0.0568 + 'px',
      'top': containerWidth * 1.1553 + 'px'
    });

    $('.landing-button-to-p2').css({
      'height': containerWidth * 0.0568 + 'px',
      'top': containerWidth * 1.4053030303 + 'px'
    });
  }
  
  resetHeaderFooter() {
    document.getElementById('App-header').style.opacity = '1';
    document.getElementById('App-footer').style.opacity = '1';
  }

  render() {
  	return <div className="main-page" style={{}}>
      <video className='bg-image' loop autoPlay muted style={{
        'zIndex': '1001',
        'transform': 'scale(1.03)'
      }}>
        <source src="/bg/landing/video.mp4" type="video/mp4"/>
      </video>

      <div id='logo-container' style={{
          'position': 'absolute',
          'zIndex': '1002',
          'left': '38%',
          'top': '24%',
          'width': '24%'
        }}>
        <img src={this.state.bgLogo} className='bg-image' id='' style={{
          'width': '100%'
        }}/>

        <Link onClick={this.resetHeaderFooter} to={routeConfig.home.en.url}>
          <div className='landing-button' style={{
            'top': '50%',
            'height': '10%',
            'width': '15%',
            'left': '28%'
          }}></div>
        </Link>

        <Link onClick={this.resetHeaderFooter} to={routeConfig.home.tc.url}>
          <div className='landing-button' style={{
            'width': '9%',
            'left': '46.5%'
          }}></div>
        </Link>

        <Link onClick={this.resetHeaderFooter} to={routeConfig.home.sc.url}>
          <div className='landing-button' style={{
            'width': '9%',
            'left': '59%'
          }}></div>
        </Link>

        <a href={routeConfig.p2.en.url}>
          <div className='landing-button-to-p2' style={{
            'top': '50%',
            'height': '10%',
            'width': '15%',
            'left': '28%'
          }}></div>
        </a>

        <a href={routeConfig.p2.tc.url}>
          <div className='landing-button-to-p2' style={{
            'width': '9%',
            'left': '46.5%'
          }}></div>
        </a>

        <a href={routeConfig.p2.sc.url}>
          <div className='landing-button-to-p2' style={{
            'width': '9%',
            'left': '59%'
          }}></div>
        </a>
      </div>

  	</div>
  }

/*
    return <div className="main-page" style={{}}>
      <img src={this.state.bg} className='bg-image' id='' style={{
        'zIndex': '1001',
        'transform': 'scale(1, 1.06)'
      }}/>
      <img src={this.state.bgLogo} className='bg-image' id='' style={{
        'zIndex': '1002'
      }}/>

      <Link onClick={this.resetHeaderFooter} to={routeConfig.home.en.url}>
        <div className='landing-button' style={{
          'width': '4.545%',
          'left': '44%'
        }}></div>
      </Link>

      <Link onClick={this.resetHeaderFooter} to={routeConfig.home.tc.url}>
        <div className='landing-button' style={{
          'width': '2.727%',
          'left': '49.5%'
        }}></div>
      </Link>

      <Link onClick={this.resetHeaderFooter} to={routeConfig.home.sc.url}>
        <div className='landing-button' style={{
          'width': '2.727%',
          'left': '53.2%'
        }}></div>
      </Link>

    </div>
*/
/*


      
      <img src={this.state.bgLogo} className='bg-image' id='' style={{
        'zIndex': '1002'
      }}/>

      <Link onClick={this.resetHeaderFooter} to={routeConfig.home.en.url}>
        <div className='landing-button' style={{
          'width': '4.545%',
          'left': '44%'
        }}></div>
      </Link>

      <Link onClick={this.resetHeaderFooter} to={routeConfig.home.tc.url}>
        <div className='landing-button' style={{
          'width': '2.727%',
          'left': '49.5%'
        }}></div>
      </Link>

      <Link onClick={this.resetHeaderFooter} to={routeConfig.home.sc.url}>
        <div className='landing-button' style={{
          'width': '2.727%',
          'left': '53.2%'
        }}></div>
      </Link>
*/
};

export default Landing;



// WEBPACK FOOTER //
// ./src/page/Landing.js